(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
      const bottom = this.header.getBoundingClientRect().bottom;
      document.documentElement.style.setProperty('--search-modal-top-position', `${bottom}px`);
      /* Keep --header-bottom-position-desktop in sync here (authoritative source).
         Megamenu max-height depends on it; if it's stale or unset, the megamenu
         collapses. Only write when the measurement is sane so a transient
         mid-load layout can't poison the value. */
      if (bottom > 0 && bottom < window.innerHeight) {
        document.documentElement.style.setProperty('--header-bottom-position-desktop', `${Math.floor(bottom)}px`);
        /* Gate release: flip <html data-header-ready> so the megamenu buttons
           become interactive. Wait for window.load so CSS, fonts, and images
           are finalized — setHeaderHeight itself runs in connectedCallback
           (early parse), which would release the gate while the page is still
           painting and users would still see mid-load breakage. */
        if (document.readyState === 'complete') {
          document.documentElement.setAttribute('data-header-ready', 'true');
        } else if (!this._readyListenerAdded) {
          this._readyListenerAdded = true;
          window.addEventListener('load', () => {
            document.documentElement.setAttribute('data-header-ready', 'true');
          }, { once: true });
        }
      }
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
      document.documentElement.style.setProperty('--search-modal-top-position', `${this.header.getBoundingClientRect().bottom}px`); 
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  /* Set header height CSS variable for transparent overlap */
  if (document.body.classList.contains('template-index') || document.querySelector('.banner--full, .banner')) {
    const sectionHeaderEl = document.querySelector('.section-header');
    if (sectionHeaderEl) {
      sectionHeaderEl.style.setProperty('--header-height', sectionHeaderEl.offsetHeight + 'px');
    }
  }

  /* Transparent/sticky header states handled by CSS in {%- style -%} block */

  } catch(e) { console.error(e); }
})();
})();
